// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.admin-panel-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
  padding: 20px;
}

.admin-panel {
  background: white;
  border-radius: 16px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  width: 100%;
  max-width: 900px;
  max-height: 90vh;
  overflow-y: auto;
  position: relative;
}

.admin-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px 32px;
  border-bottom: 2px solid #F7E9D2;
  background: linear-gradient(135deg, #FAF6E7 0%, #F7E9D2 100%);
  border-radius: 16px 16px 0 0;
}

.admin-header h2 {
  margin: 0;
  color: #3D1818;
  font-family: 'Playfair Display', serif;
  font-size: 1.8rem;
  font-weight: 600;
}

.close-btn {
  background: none;
  border: none;
  font-size: 2rem;
  color: #8B7355;
  cursor: pointer;
  padding: 0;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.close-btn:hover {
  background: rgba(139, 115, 85, 0.1);
  color: #3D1818;
}

.admin-tabs {
  display: flex;
  background: #F7E9D2;
  padding: 0 32px;
  border-bottom: 1px solid #E8D5B7;
}

.tab-btn {
  background: none;
  border: none;
  padding: 16px 24px;
  font-size: 1rem;
  font-weight: 600;
  color: #8B7355;
  cursor: pointer;
  transition: all 0.2s ease;
  border-bottom: 3px solid transparent;
  position: relative;
}

.tab-btn:hover:not(:disabled) {
  color: #3D1818;
  background: rgba(255, 255, 255, 0.3);
}

.tab-btn.active {
  color: #3D1818;
  border-bottom-color: #D4A574;
  background: white;
}

.tab-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.success-message,
.error-message {
  margin: 20px 32px;
  padding: 16px;
  border-radius: 8px;
  font-weight: 500;
}

.success-message {
  background: #E8F5E8;
  color: #2E7D32;
  border: 1px solid #A5D6A7;
}

.error-message {
  background: #FFEBEE;
  color: #C62828;
  border: 1px solid #EF9A9A;
}

.admin-form {
  padding: 32px;
}

.admin-form h3 {
  margin: 0 0 24px 0;
  color: #3D1818;
  font-family: 'Playfair Display', serif;
  font-size: 1.5rem;
  font-weight: 600;
  border-bottom: 2px solid #F7E9D2;
  padding-bottom: 12px;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
  margin-bottom: 20px;
}

.form-group {
  display: flex;
  flex-direction: column;
}

.form-group.full-width {
  grid-column: 1 / -1;
}

.form-group label {
  margin-bottom: 8px;
  font-weight: 600;
  color: #3D1818;
  font-size: 0.95rem;
}

.form-group input,
.form-group select,
.form-group textarea {
  padding: 12px 16px;
  border: 2px solid #E8D5B7;
  border-radius: 8px;
  font-size: 1rem;
  transition: all 0.2s ease;
  background: white;
  color: #3D1818;
}

.form-group input:focus,
.form-group select:focus,
.form-group textarea:focus {
  outline: none;
  border-color: #D4A574;
  box-shadow: 0 0 0 3px rgba(212, 165, 116, 0.1);
}

.form-group input[readonly] {
  background: #FAF6E7;
  color: #8B7355;
}

.form-group small {
  margin-top: 6px;
  color: #8B7355;
  font-size: 0.85rem;
  font-style: italic;
}

.promo-section {
  border: 1px dashed #D4A574;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 20px;
}

.promo-toggle {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  color: #3D1818;
  cursor: pointer;
}

.promo-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
}

.promo-regular-price {
  color: #5D3A3A;
  font-size: 0.95rem;
}

.promo-fields-row {
  display: grid;
  grid-template-columns: 1fr auto 1fr 1fr;
  gap: 16px;
  align-items: end;
  margin-top: 16px;
}

.promo-or {
  padding-bottom: 12px;
  color: #8B7355;
  font-style: italic;
}

.promo-hint {
  display: block;
  margin-top: 6px;
  color: #8B7355;
  font-size: 0.85rem;
  font-style: italic;
}

@media (max-width: 768px) {
  .promo-fields-row {
    grid-template-columns: 1fr;
  }

  .promo-or {
    padding-bottom: 0;
  }
}

.promotions-manager {
  padding: 32px;
}

.promotions-toolbar {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 20px;
}

.promotions-toolbar h3 {
  margin: 0;
  flex: 1;
  color: #3D1818;
  font-family: 'Playfair Display', serif;
  font-size: 1.5rem;
  font-weight: 600;
}

.promotions-toolbar select {
  padding: 6px 10px;
  border: 1px solid #D4A574;
  border-radius: 6px;
  background: white;
}

.promotions-count {
  font-weight: 600;
  color: #B22222;
}

.promotions-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.promotion-row {
  border: 1px solid #E8D8C4;
  border-left: 4px solid #E8D8C4;
  border-radius: 8px;
  padding: 12px 16px;
  background: #FFFDF9;
}

.promotion-row.promotion-active {
  border-left-color: #B22222;
}

.promotion-row.promotion-expired {
  border-left-color: #8B7355;
}

.promotion-summary {
  display: flex;
  align-items: center;
  gap: 16px;
}

.promotion-thumb {
  width: 48px;
  height: 64px;
  object-fit: contain;
}

.promotion-info {
  flex: 1;
}

.promotion-info h4 {
  margin: 0 0 4px;
  color: #3D1818;
}

.promotion-prices {
  margin: 0 0 6px;
  color: #3D1818;
}

.promotion-prices s {
  color: #8B7355;
  margin-right: 6px;
}

.promotion-badge {
  display: inline-block;
  padding: 2px 10px;
  border-radius: 12px;
  font-size: 0.8rem;
  font-weight: 600;
}

.promotion-badge-active {
  background: #B22222;
  color: white;
}

.promotion-badge-expired {
  background: #EFE6DA;
  color: #5D3A3A;
}

.promotion-badge-none {
  background: #F4F0EA;
  color: #8B7355;
}

.promotion-actions {
  display: flex;
  gap: 8px;
}

.promotion-editor {
  margin-top: 12px;
}

.promotion-editor .promo-section {
  margin-bottom: 12px;
}

.promo-preview {
  margin: 12px 0 0;
  font-weight: 600;
  color: #B22222;
}

.promo-warning {
  margin: 8px 0 0;
  padding: 8px 12px;
  background: #FFF4E5;
  border-left: 3px solid #E69500;
  color: #7A4B00;
  font-size: 0.9rem;
}

.product-promo {
  margin: 0 0 6px 0;
  color: #B22222;
  font-weight: 600;
  font-size: 0.85rem;
}

.form-actions {
  display: flex;
  gap: 16px;
  margin-top: 32px;
  padding-top: 24px;
  border-top: 2px solid #F7E9D2;
}

.submit-btn,
.reset-btn {
  padding: 14px 28px;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.submit-btn {
  background: #D4A574;
  color: white;
}

.submit-btn:hover:not(:disabled) {
  background: #C19A6B;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(212, 165, 116, 0.3);
}

.submit-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.reset-btn {
  background: #E8D5B7;
  color: #3D1818;
}

.reset-btn:hover {
  background: #D4A574;
  color: white;
}

.products-list {
  padding: 32px;
}

.products-list h3 {
  margin: 0 0 24px 0;
  color: #3D1818;
  font-family: 'Playfair Display', serif;
  font-size: 1.5rem;
  font-weight: 600;
}

.loading,
.no-products {
  text-align: center;
  padding: 40px;
  color: #8B7355;
  font-size: 1.1rem;
}

.products-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 24px;
}

.product-item {
  background: white;
  border: 2px solid #F7E9D2;
  border-radius: 12px;
  overflow: hidden;
  transition: all 0.2s ease;
}

.product-item:hover {
  border-color: #D4A574;
  box-shadow: 0 8px 24px rgba(212, 165, 116, 0.2);
  transform: translateY(-4px);
}

.product-thumbnail {
  width: 100%;
  height: 180px;
  object-fit: cover;
  border-bottom: 1px solid #F7E9D2;
}

.product-info {
  padding: 16px;
}

.product-info h4 {
  margin: 0 0 8px 0;
  color: #3D1818;
  font-size: 1.1rem;
  font-weight: 600;
}

.product-price {
  margin: 0 0 6px 0;
  color: #D4A574;
  font-weight: 600;
  font-size: 0.95rem;
}

.product-type {
  margin: 0;
  color: #8B7355;
  font-size: 0.85rem;
  font-style: italic;
}

.product-actions {
  display: flex;
  gap: 8px;
  padding: 16px;
  border-top: 1px solid #F7E9D2;
  background: #FAF6E7;
}

.edit-btn,
.delete-btn {
  flex: 1;
  padding: 8px 16px;
  border: none;
  border-radius: 6px;
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.edit-btn {
  background: #D4A574;
  color: white;
}

.edit-btn:hover {
  background: #C19A6B;
}

.delete-btn {
  background: #E8D5B7;
  color: #8B7355;
}

.delete-btn:hover {
  background: #D4A574;
  color: white;
}

.apply-changes-btn {
  padding: 12px 24px;
  background: #4CAF50;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(76, 175, 80, 0.3);
  display: flex;
  align-items: center;
  gap: 8px;
}

.apply-changes-btn:hover:not(:disabled) {
  background: #45a049;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(76, 175, 80, 0.4);
}

.apply-changes-btn:active:not(:disabled) {
  transform: translateY(0);
}

.apply-changes-btn:disabled {
  background: #cccccc;
  cursor: not-allowed;
  opacity: 0.6;
}

/* Responsive Design */
@media (max-width: 768px) {
  .admin-panel {
    margin: 10px;
    max-height: 95vh;
  }
  
  .admin-header {
    padding: 20px 24px;
  }
  
  .admin-header h2 {
    font-size: 1.5rem;
  }
  
  .admin-tabs {
    padding: 0 24px;
    flex-wrap: wrap;
  }
  
  .tab-btn {
    padding: 12px 16px;
    font-size: 0.9rem;
  }
  
  .admin-form,
  .products-list {
    padding: 24px;
  }
  
  .form-row {
    grid-template-columns: 1fr;
    gap: 16px;
  }
  
  .form-actions {
    flex-direction: column;
  }
  
  .products-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 480px) {
  .admin-panel-overlay {
    padding: 10px;
  }
  
  .admin-panel {
    border-radius: 12px;
  }
  
  .admin-header {
    padding: 16px 20px;
  }
  
  .admin-header h2 {
    font-size: 1.3rem;
  }
  
  .admin-tabs {
    padding: 0 20px;
  }
  
  .tab-btn {
    padding: 10px 12px;
    font-size: 0.85rem;
  }
  
  .admin-form,
  .products-list {
    padding: 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/AdminPanel.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAC1C,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;EAChC,6DAA6D;EAC7D,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,cAAc;EACd,sCAAsC;EACtC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,eAAe;EACf,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;EAEE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,sCAAsC;EACtC,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;;;EAGE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;;EAGE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uCAAuC;EACvC,SAAS;EACT,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,OAAO;EACP,cAAc;EACd,sCAAsC;EACtC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;EAC9B,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;;EAEE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,sCAAsC;EACtC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,+CAA+C;EAC/C,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;;EAEE,OAAO;EACP,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,4CAA4C;EAC5C,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;AACd;;AAEA,sBAAsB;AACtB;EACE;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;;IAEE,aAAa;EACf;AACF","sourcesContent":[".admin-panel-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.7);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 2000;\n  padding: 20px;\n}\n\n.admin-panel {\n  background: white;\n  border-radius: 16px;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\n  width: 100%;\n  max-width: 900px;\n  max-height: 90vh;\n  overflow-y: auto;\n  position: relative;\n}\n\n.admin-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 24px 32px;\n  border-bottom: 2px solid #F7E9D2;\n  background: linear-gradient(135deg, #FAF6E7 0%, #F7E9D2 100%);\n  border-radius: 16px 16px 0 0;\n}\n\n.admin-header h2 {\n  margin: 0;\n  color: #3D1818;\n  font-family: 'Playfair Display', serif;\n  font-size: 1.8rem;\n  font-weight: 600;\n}\n\n.close-btn {\n  background: none;\n  border: none;\n  font-size: 2rem;\n  color: #8B7355;\n  cursor: pointer;\n  padding: 0;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n}\n\n.close-btn:hover {\n  background: rgba(139, 115, 85, 0.1);\n  color: #3D1818;\n}\n\n.admin-tabs {\n  display: flex;\n  background: #F7E9D2;\n  padding: 0 32px;\n  border-bottom: 1px solid #E8D5B7;\n}\n\n.tab-btn {\n  background: none;\n  border: none;\n  padding: 16px 24px;\n  font-size: 1rem;\n  font-weight: 600;\n  color: #8B7355;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  border-bottom: 3px solid transparent;\n  position: relative;\n}\n\n.tab-btn:hover:not(:disabled) {\n  color: #3D1818;\n  background: rgba(255, 255, 255, 0.3);\n}\n\n.tab-btn.active {\n  color: #3D1818;\n  border-bottom-color: #D4A574;\n  background: white;\n}\n\n.tab-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.success-message,\n.error-message {\n  margin: 20px 32px;\n  padding: 16px;\n  border-radius: 8px;\n  font-weight: 500;\n}\n\n.success-message {\n  background: #E8F5E8;\n  color: #2E7D32;\n  border: 1px solid #A5D6A7;\n}\n\n.error-message {\n  background: #FFEBEE;\n  color: #C62828;\n  border: 1px solid #EF9A9A;\n}\n\n.admin-form {\n  padding: 32px;\n}\n\n.admin-form h3 {\n  margin: 0 0 24px 0;\n  color: #3D1818;\n  font-family: 'Playfair Display', serif;\n  font-size: 1.5rem;\n  font-weight: 600;\n  border-bottom: 2px solid #F7E9D2;\n  padding-bottom: 12px;\n}\n\n.form-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 24px;\n  margin-bottom: 20px;\n}\n\n.form-group {\n  display: flex;\n  flex-direction: column;\n}\n\n.form-group.full-width {\n  grid-column: 1 / -1;\n}\n\n.form-group label {\n  margin-bottom: 8px;\n  font-weight: 600;\n  color: #3D1818;\n  font-size: 0.95rem;\n}\n\n.form-group input,\n.form-group select,\n.form-group textarea {\n  padding: 12px 16px;\n  border: 2px solid #E8D5B7;\n  border-radius: 8px;\n  font-size: 1rem;\n  transition: all 0.2s ease;\n  background: white;\n  color: #3D1818;\n}\n\n.form-group input:focus,\n.form-group select:focus,\n.form-group textarea:focus {\n  outline: none;\n  border-color: #D4A574;\n  box-shadow: 0 0 0 3px rgba(212, 165, 116, 0.1);\n}\n\n.form-group input[readonly] {\n  background: #FAF6E7;\n  color: #8B7355;\n}\n\n.form-group small {\n  margin-top: 6px;\n  color: #8B7355;\n  font-size: 0.85rem;\n  font-style: italic;\n}\n\n.promo-section {\n  border: 1px dashed #D4A574;\n  border-radius: 8px;\n  padding: 16px;\n  margin-bottom: 20px;\n}\n\n.promo-toggle {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-weight: 600;\n  color: #3D1818;\n  cursor: pointer;\n}\n\n.promo-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 12px;\n}\n\n.promo-regular-price {\n  color: #5D3A3A;\n  font-size: 0.95rem;\n}\n\n.promo-fields-row {\n  display: grid;\n  grid-template-columns: 1fr auto 1fr 1fr;\n  gap: 16px;\n  align-items: end;\n  margin-top: 16px;\n}\n\n.promo-or {\n  padding-bottom: 12px;\n  color: #8B7355;\n  font-style: italic;\n}\n\n.promo-hint {\n  display: block;\n  margin-top: 6px;\n  color: #8B7355;\n  font-size: 0.85rem;\n  font-style: italic;\n}\n\n@media (max-width: 768px) {\n  .promo-fields-row {\n    grid-template-columns: 1fr;\n  }\n\n  .promo-or {\n    padding-bottom: 0;\n  }\n}\n\n.promotions-manager {\n  padding: 32px;\n}\n\n.promotions-toolbar {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  margin-bottom: 20px;\n}\n\n.promotions-toolbar h3 {\n  margin: 0;\n  flex: 1;\n  color: #3D1818;\n  font-family: 'Playfair Display', serif;\n  font-size: 1.5rem;\n  font-weight: 600;\n}\n\n.promotions-toolbar select {\n  padding: 6px 10px;\n  border: 1px solid #D4A574;\n  border-radius: 6px;\n  background: white;\n}\n\n.promotions-count {\n  font-weight: 600;\n  color: #B22222;\n}\n\n.promotions-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.promotion-row {\n  border: 1px solid #E8D8C4;\n  border-left: 4px solid #E8D8C4;\n  border-radius: 8px;\n  padding: 12px 16px;\n  background: #FFFDF9;\n}\n\n.promotion-row.promotion-active {\n  border-left-color: #B22222;\n}\n\n.promotion-row.promotion-expired {\n  border-left-color: #8B7355;\n}\n\n.promotion-summary {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.promotion-thumb {\n  width: 48px;\n  height: 64px;\n  object-fit: contain;\n}\n\n.promotion-info {\n  flex: 1;\n}\n\n.promotion-info h4 {\n  margin: 0 0 4px;\n  color: #3D1818;\n}\n\n.promotion-prices {\n  margin: 0 0 6px;\n  color: #3D1818;\n}\n\n.promotion-prices s {\n  color: #8B7355;\n  margin-right: 6px;\n}\n\n.promotion-badge {\n  display: inline-block;\n  padding: 2px 10px;\n  border-radius: 12px;\n  font-size: 0.8rem;\n  font-weight: 600;\n}\n\n.promotion-badge-active {\n  background: #B22222;\n  color: white;\n}\n\n.promotion-badge-expired {\n  background: #EFE6DA;\n  color: #5D3A3A;\n}\n\n.promotion-badge-none {\n  background: #F4F0EA;\n  color: #8B7355;\n}\n\n.promotion-actions {\n  display: flex;\n  gap: 8px;\n}\n\n.promotion-editor {\n  margin-top: 12px;\n}\n\n.promotion-editor .promo-section {\n  margin-bottom: 12px;\n}\n\n.promo-preview {\n  margin: 12px 0 0;\n  font-weight: 600;\n  color: #B22222;\n}\n\n.promo-warning {\n  margin: 8px 0 0;\n  padding: 8px 12px;\n  background: #FFF4E5;\n  border-left: 3px solid #E69500;\n  color: #7A4B00;\n  font-size: 0.9rem;\n}\n\n.product-promo {\n  margin: 0 0 6px 0;\n  color: #B22222;\n  font-weight: 600;\n  font-size: 0.85rem;\n}\n\n.form-actions {\n  display: flex;\n  gap: 16px;\n  margin-top: 32px;\n  padding-top: 24px;\n  border-top: 2px solid #F7E9D2;\n}\n\n.submit-btn,\n.reset-btn {\n  padding: 14px 28px;\n  border: none;\n  border-radius: 8px;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.submit-btn {\n  background: #D4A574;\n  color: white;\n}\n\n.submit-btn:hover:not(:disabled) {\n  background: #C19A6B;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(212, 165, 116, 0.3);\n}\n\n.submit-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.reset-btn {\n  background: #E8D5B7;\n  color: #3D1818;\n}\n\n.reset-btn:hover {\n  background: #D4A574;\n  color: white;\n}\n\n.products-list {\n  padding: 32px;\n}\n\n.products-list h3 {\n  margin: 0 0 24px 0;\n  color: #3D1818;\n  font-family: 'Playfair Display', serif;\n  font-size: 1.5rem;\n  font-weight: 600;\n}\n\n.loading,\n.no-products {\n  text-align: center;\n  padding: 40px;\n  color: #8B7355;\n  font-size: 1.1rem;\n}\n\n.products-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n  gap: 24px;\n}\n\n.product-item {\n  background: white;\n  border: 2px solid #F7E9D2;\n  border-radius: 12px;\n  overflow: hidden;\n  transition: all 0.2s ease;\n}\n\n.product-item:hover {\n  border-color: #D4A574;\n  box-shadow: 0 8px 24px rgba(212, 165, 116, 0.2);\n  transform: translateY(-4px);\n}\n\n.product-thumbnail {\n  width: 100%;\n  height: 180px;\n  object-fit: cover;\n  border-bottom: 1px solid #F7E9D2;\n}\n\n.product-info {\n  padding: 16px;\n}\n\n.product-info h4 {\n  margin: 0 0 8px 0;\n  color: #3D1818;\n  font-size: 1.1rem;\n  font-weight: 600;\n}\n\n.product-price {\n  margin: 0 0 6px 0;\n  color: #D4A574;\n  font-weight: 600;\n  font-size: 0.95rem;\n}\n\n.product-type {\n  margin: 0;\n  color: #8B7355;\n  font-size: 0.85rem;\n  font-style: italic;\n}\n\n.product-actions {\n  display: flex;\n  gap: 8px;\n  padding: 16px;\n  border-top: 1px solid #F7E9D2;\n  background: #FAF6E7;\n}\n\n.edit-btn,\n.delete-btn {\n  flex: 1;\n  padding: 8px 16px;\n  border: none;\n  border-radius: 6px;\n  font-size: 0.85rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.edit-btn {\n  background: #D4A574;\n  color: white;\n}\n\n.edit-btn:hover {\n  background: #C19A6B;\n}\n\n.delete-btn {\n  background: #E8D5B7;\n  color: #8B7355;\n}\n\n.delete-btn:hover {\n  background: #D4A574;\n  color: white;\n}\n\n.apply-changes-btn {\n  padding: 12px 24px;\n  background: #4CAF50;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 2px 8px rgba(76, 175, 80, 0.3);\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.apply-changes-btn:hover:not(:disabled) {\n  background: #45a049;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 12px rgba(76, 175, 80, 0.4);\n}\n\n.apply-changes-btn:active:not(:disabled) {\n  transform: translateY(0);\n}\n\n.apply-changes-btn:disabled {\n  background: #cccccc;\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .admin-panel {\n    margin: 10px;\n    max-height: 95vh;\n  }\n  \n  .admin-header {\n    padding: 20px 24px;\n  }\n  \n  .admin-header h2 {\n    font-size: 1.5rem;\n  }\n  \n  .admin-tabs {\n    padding: 0 24px;\n    flex-wrap: wrap;\n  }\n  \n  .tab-btn {\n    padding: 12px 16px;\n    font-size: 0.9rem;\n  }\n  \n  .admin-form,\n  .products-list {\n    padding: 24px;\n  }\n  \n  .form-row {\n    grid-template-columns: 1fr;\n    gap: 16px;\n  }\n  \n  .form-actions {\n    flex-direction: column;\n  }\n  \n  .products-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 480px) {\n  .admin-panel-overlay {\n    padding: 10px;\n  }\n  \n  .admin-panel {\n    border-radius: 12px;\n  }\n  \n  .admin-header {\n    padding: 16px 20px;\n  }\n  \n  .admin-header h2 {\n    font-size: 1.3rem;\n  }\n  \n  .admin-tabs {\n    padding: 0 20px;\n  }\n  \n  .tab-btn {\n    padding: 10px 12px;\n    font-size: 0.85rem;\n  }\n  \n  .admin-form,\n  .products-list {\n    padding: 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
